<template>
  <!-- 指数查询管理 -->
  <div class="account_manage">
    <query-search
      ref="searchBox"
      class="search_box"
      @search-change="changeSearch"
    ></query-search>
    <query-table
      class="search_table"
      :loading="loading"
      :companyList="companyList"
      :params="tableParams"
      @export="exportFunc"
      @change-page="changePage"
      @update="getQueryList"
    ></query-table>
  </div>
</template>

<script>
import querySearch from './querySearch.vue'
import queryTable from './queryTable.vue'
import { Message } from 'element-ui'
export default {
  name: 'AccountManage',
  components: {
    querySearch,
    queryTable,
  },
  data() {
    return {
      companyList: [], //账号列表
      tableParams: {
        // 分页器的参数
        total: 0,
        page: 1,
        size: 20,
      },
      loading: false,
    }
  },
  computed: {},
  mounted() {
    // this.getEnterprise();
    this.getQueryList()
  },
  methods: {
    // 获取账号列表
    getQueryList(val) {
      this.loading = true
      const data = {
        page: this.tableParams.page,
        size: this.tableParams.size,
        body: val || this.$refs.searchBox.searchForm,
      }
      this.$http({
        url: '/searchData/findByPage',
        method: 'post',
        data: data,
      })
        .then((res) => {
          if (res.code === 200) {
            this.companyList = res.data.list || []
            this.tableParams.total = res.data.total
          } else {
            this.$message({
              message: res.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            message: '获取指数查询接口请求失败',
            type: 'error',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 搜索更新
    changeSearch(val) {
      this.tableParams.page = 1
      this.getQueryList(val)
    },
    changePage(page) {
      this.tableParams.page = page
      this.getQueryList()
    },
    exportFunc() {
      const data = {
        body: this.$refs.searchBox.searchForm,
      }
      this.$http({
        url: '/searchData/download',
        method: 'post',
        data,
        responseType: 'blob',
      })
        .then((res) => {
          console.log(res)
          if (res.type === 'application/json') {
            let reader = new FileReader()
            reader.onload = (e) => {
              const result = JSON.parse(e.target.result)
              if (result.code === 0) {
                Message.success(message || result.message)
              } else {
                Message.error(result.message)
              }
            }
            reader.readAsText(res)
          } else {
            if (res) {
              const blob = new Blob([res], {})
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob)
              } else {
                let link = document.createElement('a')
                link.download = '指数导出.xlsx'
                link.href = window.URL.createObjectURL(blob)
                link.click()
                window.URL.revokeObjectURL(link)
              }
              Message.success('正在下载中，请稍等...')
            } else {
              Message.error('下载失败')
            }
          }
        })
        .catch((res) => {
          Message.error('下载失败')
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.account_manage {
  height: 100%;
  display: flex;
  flex-direction: column;
  .search_table {
    flex: 1;
    height: 0;
  }
}

// .form {
//   width: 668px;
//   flex-shrink: 0;
// }
// $logo-size: 32px;
// .logo {
//   width: $logo-size;
//   height: $logo-size;
// }
</style>



// WEBPACK FOOTER //
// src/pages/index/views/indexQuery/index.vue